var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrderAscendingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Table---Dropdown",
    transform: "translate(-28.000000, -102.000000)",
    fill: "#F0B423"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,112 L30,112 L30,118 L28,118 L28,112 Z M42,102 L44,102 L44,118 L42,118 L42,102 Z M35,107 L37,107 L37,118 L35,118 L35,107 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderAscendingActive);
export default __webpack_public_path__ + "static/media/Icon_Order_Ascending-Active.5e2491bbba94b11580d8ee8dfcd19660.svg";
export { ForwardRef as ReactComponent };